import * as React from "react";

import { mergeOverrides } from "baseui/helpers/overrides";
import { Radio as BaseRadio, RadioProps } from "baseui/radio";

const Radio: React.FC<RadioProps> = (props) => (
  <BaseRadio
    {...props}
    overrides={props.overrides ? mergeOverrides(overrides, props.overrides) : overrides}
  />
);

const overrides: RadioProps["overrides"] = {
  RadioMarkOuter: {
    style: ({ $theme, $checked }) => ({
      width: "24px",
      height: "24px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: $checked
        ? $theme.colors.borderSelected
        : $theme.colors.contentTertiary,
      backgroundColor: $checked ? $theme.colors.primary : $theme.colors.background,
    }),
  },
  RadioMarkInner: {
    style: ({ $theme, $checked }) => ({
      width: "14px",
      height: "14px",
      backgroundColor: $checked ? $theme.colors.primary : $theme.colors.background,
    }),
  },
};

export { Radio };
